import React from 'react';
import ErrorBoundaryWrapper from '@gameday/components/ErrorFallback/ErrorBoundaryWrapper';
import { routes as TeamSummaryMatchupRoutes } from '../../TeamSummaryMatchup/TeamSummaryMatchupDataContainer';
import { routes as BroadcastersRoutesRoutes } from '../../Broadcasters/containers/BroadcastersDataContainer';
import { routes as PitchFXRoutes } from '../../PitchFx/PitchFxDataContainer';

import LiveMini from '../LiveMini';
import GDBREAKPOINTS from '@gameday/components/themes/breakpoints';
import { useMedia } from '@mlb/react-patterns/v4/utils/hooks/useMedia/useMedia';

const { SM_REG_MAX } = GDBREAKPOINTS;

const routes = [{
    path: '/',
    exact: false,
    routes: [
        ...PitchFXRoutes,
        ...TeamSummaryMatchupRoutes,
        ...BroadcastersRoutesRoutes
    ]
}];

const LiveMiniDataContainer = () => {
    const isMobile = useMedia({ maxWidth: SM_REG_MAX });

    return (
        <ErrorBoundaryWrapper componentName='LiveMiniDataContainer'>
            <LiveMini isMobile={isMobile} />
        </ErrorBoundaryWrapper>
    );
};

export default LiveMiniDataContainer;
export { routes };
